import { render, staticRenderFns } from "./IconAddRowAfter.vue?vue&type=template&id=5a2318d8"
import script from "./IconAddRowAfter.vue?vue&type=script&lang=js"
export * from "./IconAddRowAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports